import { InfoWindowF, MarkerF } from '@react-google-maps/api';
import React, { useState } from 'react';
import PipeInfoWindow from './PipeInfoWindow';

const PipeMarker = ({
  marker,
  clusterer,
  icon,
  color,
  status,
  size,
  onClick,
}) => {
  const statusKey = status?.toLowerCase()?.split('_')?.join('') ?? 'approved';

  const className = `pipe-marker-label pipe-marker-label-${statusKey} ${
    marker?.isLate && !marker?.isIncomplete ? 'pipe-late' : ''
  } ${marker?.isIncomplete ? 'pipe-incomplete' : ''}`;

  const [hoveredMarker, setHoveredMarker] = useState(null);

  const handleMarkerHover = (id) => {
    setHoveredMarker(id);
    if (!id) window.google.maps.event.clearInstanceListeners(marker);
  };

  const canShowInfoWindow = hoveredMarker === marker?.id;

  return (
    <MarkerF
      className="pipe-marker"
      key={marker.id}
      position={marker}
      clusterer={clusterer}
      icon={{
        url: icon,
        scaledSize: new window.google.maps.Size(
          size?.width ?? 35,
          size?.height ?? 40
        ),
        size: new window.google.maps.Size(
          size?.width ?? 35,
          size?.height ?? 40
        ),
      }}
      label={{
        text: marker?.label || '',
        fontWeight: 'bold',
        fontSize: '12.5px',
        color,
        className,
      }}
      onMouseOver={() => handleMarkerHover(marker?.id)}
      onMouseOut={() => handleMarkerHover(null)}
      onClick={(e) => {
        e.stop();
        // onClick?.(marker);
      }}
    >
      {canShowInfoWindow && (
        <InfoWindowF
          position={marker}
          onCloseclick={() =>
            window.google.maps.event.clearInstanceListeners(marker)
          }
        >
          <PipeInfoWindow marker={marker} />
        </InfoWindowF>
      )}
    </MarkerF>
  );
};

export default PipeMarker;
